<template>
  <div class="insurance-company__wrapper">
    <div class="insurance-company__title-block">
      <h5 class="insurance-company__title">{{ title }}</h5>
      <p class="insurance-company__description">
        <slot />
      </p>
    </div>
    <TransparencyFancyButton
      class="insurance-company__link"
      :route="route"
    >
      <span class="insurance-company__button-text">Перелік послуг</span>
      <span class="insurance-company__button-icon"><ContactIcon /></span>
    </TransparencyFancyButton>
  </div>
</template>

<script>
import { TransparencyFancyButton } from '@/shared/ui/form';
import { ContactIcon } from '@/shared/ui/icons';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    route: {
      type: [Object, String],
      default: '',
    },
  },
  components: { TransparencyFancyButton, ContactIcon },
};
</script>

<style lang="scss" scoped>
.insurance-company {
  &__wrapper {
    display: flex;
    flex-direction: column;
    background-color: #EBF2FF;
    border-radius: 16px;
    padding: 16px;
  }

  &__title-block {
    flex: 1;
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 20px;
    font-weight: 500;
    color: #313437;
    margin-bottom: 10px;
  }

  &__description {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #313957;
    margin-bottom: 10px;
  }

  &__link {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  &__button-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #FFFFFF;
    border-radius: 50%;
    margin-left: 10px;
  }
}
</style>
